import React from 'react';

/**
 * Eyebrow — the signature label component (PHASE-1.5-BRAND-SPEC.md §4).
 * 6px filled circle, 8px gap, then the label: JetBrains Mono 500, 12px,
 * letter-spacing 0.18em, ALL-CAPS. Dot and text share the tone color.
 * Tones (dark surface / light surface): gold #DB9E33 / #CA9612,
 * teal #2DD4BF / #0F766E, blue #3385FF / #0066FF.
 */
const TONES = {
  gold: { dark: '#DB9E33', light: '#CA9612' },
  teal: { dark: '#2DD4BF', light: '#0F766E' },
  blue: { dark: '#3385FF', light: '#0066FF' },
};

export const Eyebrow = ({ label, tone = 'gold', light = false }) => {
  const color = (TONES[tone] || TONES.gold)[light ? 'light' : 'dark'];
  return (
    <span
      data-testid="eyebrow"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        fontFamily: 'var(--font-eyebrow)',
        fontWeight: 500,
        fontSize: '12px',
        letterSpacing: '0.18em',
        textTransform: 'uppercase',
        color,
      }}
    >
      <span
        aria-hidden="true"
        style={{
          width: '6px',
          height: '6px',
          borderRadius: '50%',
          backgroundColor: color,
          flexShrink: 0,
        }}
      />
      {label}
    </span>
  );
};

export default Eyebrow;
